export enum TableMode {
    Edit = 1,
    View = 2
}

export enum FilterTypes {
    default = 1,
    dropDown = 2
}